import React from "react";
import AdminModal from "../common/AdminModal";

const ThoughtPlayer = ({ handleCancel, videoUrlData }) => {
  if (!videoUrlData?.videoUrl) return null;

  window.addEventListener("dyntubeReady", () => {
    var player = dyntube.getPlayer(videoUrlData?.videoUrl);
    player.play();
  });

  return (
    <AdminModal
      centered
      onCancel={handleCancel}
      visible={true}
      footer={null}
      width={1100}
      bodyStyle={{
        padding: "0px",
      }}
    >
      <div data-dyntube-key={videoUrlData?.videoUrl}></div>
    </AdminModal>
  );
};

export default ThoughtPlayer;
